var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bi_25_669)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 66,
    rx: 33,
    transform: "matrix(-1 0 0 1 66 0)",
    fill: "url(#paint0_linear_25_669)",
    fillOpacity: 0.4
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25_669)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.2929 32.2931C29.1054 32.4806 29.0001 32.7349 29.0001 33.0001C29.0001 33.2652 29.1054 33.5195 29.2929 33.7071L34.9499 39.3641C35.0421 39.4596 35.1525 39.5358 35.2745 39.5882C35.3965 39.6406 35.5277 39.6682 35.6605 39.6693C35.7933 39.6705 35.925 39.6452 36.0479 39.5949C36.1708 39.5446 36.2824 39.4703 36.3763 39.3765C36.4702 39.2826 36.5444 39.1709 36.5947 39.048C36.645 38.9251 36.6703 38.7934 36.6692 38.6607C36.668 38.5279 36.6404 38.3967 36.588 38.2747C36.5356 38.1526 36.4594 38.0423 36.3639 37.9501L31.4139 33.0001L36.3639 28.0501C36.5461 27.8615 36.6469 27.6089 36.6446 27.3467C36.6423 27.0845 36.5371 26.8336 36.3517 26.6482C36.1663 26.4628 35.9155 26.3577 35.6533 26.3554C35.3911 26.3531 35.1385 26.4539 34.9499 26.6361L29.2929 32.2931Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bi_25_669",
    x: -100,
    y: -100,
    width: 266,
    height: 266,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 50
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_25_669"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_25_669",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_25_669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_25_669",
    x1: 66,
    y1: 30.871,
    x2: 0.0327684,
    y2: 32.4139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B1B37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.166667,
    stopColor: "#010A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F293D",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25_669"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "matrix(-1 0 0 1 45 21)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.a5187e9c722e7fccbf294e36ef49e6a0.svg";
export { ForwardRef as ReactComponent };